import { render, staticRenderFns } from "./MarketplaceOrdersList.vue?vue&type=template&id=d254a64e&scoped=true"
import script from "./MarketplaceOrdersList.vue?vue&type=script&lang=js"
export * from "./MarketplaceOrdersList.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceOrdersList.vue?vue&type=style&index=0&id=d254a64e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d254a64e",
  null
  
)

export default component.exports